import { render } from "./DuplicateListInListGroupModal.vue?vue&type=template&id=5169a6af"
import script from "./DuplicateListInListGroupModal.vue?vue&type=script&lang=js"
export * from "./DuplicateListInListGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__